import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { PreferredLanguageContext } from "../../lib/main-context";

import Sallie from "../UIComponents/Sallie";
import SubmitButton from "../UIComponents/SubmitButton";
import futureView from "../../images/FutureView2.png";

import { REGISTRATION } from "../../constants/OnboardingTranslation";

const Register = () => {
  const history = useHistory();
  const handleClick = () => {
    history.push("/BasicInfo");
  };

  const { language } = useContext(PreferredLanguageContext);
  const t = REGISTRATION[language];

  return (
    <>
      <div className="flex flex-col md:flex-row gap-8 mt-2 items-center">
        <div className="flex flex-col md:w-1/2">
          <Sallie text={t.sallie} variant="wave" />
          <p>{t.part_one}</p>
          <p>{t.part_two}</p>
          <h6>{t.header}</h6>
          <p>{t.watch_videos}</p>
        </div>
        <div className="flex flex-col md:w-1/2 items-center">
          <div className="w-full h-[300px] overflow-hidden !border border-cyan-700 rounded mb-2">
            <img
              className="w-full h-full object-cover object-top"
              src={futureView}
              alt="Preview of the future dashboard"
              loading="lazy"
            />
          </div>
          <h6 className="text-center">{t.future_dashboard}</h6>
        </div>
      </div>
      <div className="grid md:grid-cols-3 gap-4 my-4">
        <div className="flex flex-col items-center">
          <h6>{t.introduction_video}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/J8ZTtsMRCvg"
            title={t.introduction_video}
            aria-label={t.introduction_video}
            allowFullScreen
            loading="lazy"
          />
        </div>
        <div className="flex flex-col items-center">
          <h6>{t.for_patients}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/_HrjL5xB1nM"
            title={t.for_patients}
            aria-label={t.for_patients}
            allowFullScreen
            loading="lazy"
          />
        </div>
        <div className="flex flex-col items-center">
          <h6>{t.for_therapists}</h6>
          <iframe
            className="w-full h-48 rounded"
            src="https://www.youtube.com/embed/xfeCmiZf_No"
            title={t.for_therapists}
            aria-label={t.for_therapists}
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
      <a href="/signIn" className="text-teal-500 hover:text-teal-700">
        Already have an account? Click here to sign in!
      </a>
      <SubmitButton
        type="button"
        onClick={handleClick}
        aria-label={`${t.start} - Navigate to basic information form`}
      >
        {t.start} &gt;
      </SubmitButton>
    </>
  );
};

export default Register;
